<template>
	<div class="animated fadeIn">
		<b-card>
			<b-tabs v-model="activeTab" active>
				<b-tab title="Zahtevki">
					<b-card>
						<vue-loading :active.sync="warrantyClaimsTableProps.isLoading" :is-full-page="false"/>
						<vue-loading :active.sync="isLoadingConfirmingPayment" :is-full-page="false" />
						<vue-loading :active.sync="isLoadingUnconfirmingPayment" :is-full-page="false" />
						<div slot="header">
							<div class="card-header-actions">
								<CInputCheckbox :checked.sync="warrantyClaimsTableProps.inputFilter.showArchived" @change="change_showArchived" label="Prikaži potrjene" inline />
								<CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimsTableRefresh">
									<CIcon name="cil-loop-circular" class="mb-1"/>
								</CLink>
								<CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimsTableResetFilters">
									<CIcon name="cil-x" class="mb-1"/>
								</CLink>
								<CLink title="Uvozi zahtevke" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimsImport">
									<CIcon name="cil-cloud-upload" class="mb-1"/>
								</CLink>
							</div>
						</div>
						<b-table
							class="warrantyClaimsTable"
							ref="warrantyClaimsTable"
							responsive="sm"
							striped
							show-empty
							hover
							:empty-text="warrantyClaimsTableProps.empty_text"
							:empty-filtered-text="warrantyClaimsTableProps.empty_filtered_text"
							:fields="warrantyClaimsTableFields"
							:current-page="warrantyClaimsTableProps.currentPage"
							:per-page="warrantyClaimsTableProps.itemsPerPage"
							:items="warrantyClaimsTable_items"
							:sort-by.sync="warrantyClaimsTableProps.sortBy"
							:sort-desc.sync="warrantyClaimsTableProps.sortDesc"
							@row-clicked="rowClicked">
							<template slot="top-row">
								<td></td>
								<td><b-form-input v-model="warrantyClaimsTableProps.inputFilter.invoiceNumber" type="text" @input="warrantyClaimsTableTextFilter_change"/></td>
								<td><date-filter-dropdown ref="warrantyClaimsInvoiceDateFilter" v-model="warrantyClaimsTableProps.inputFilter.invoiceDate" @input="warrantyClaimsTableFilter_change" v-bind:noFutureValues="true"/></td>
								<td><b-form-input v-model="warrantyClaimsTableProps.inputFilter.orderNumber" type="text" @input="warrantyClaimsTableTextFilter_change"/></td>
								<td><b-form-input v-model="warrantyClaimsTableProps.inputFilter.customerNumber" type="text" @input="warrantyClaimsTableTextFilter_change"/></td>
								<td><b-form-input v-model="warrantyClaimsTableProps.inputFilter.ordererTitle" type="text" @input="warrantyClaimsTableTextFilter_change"/></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
							</template>
							<template v-slot:cell(invoice_date)="data">
								<span v-if="data.item.invoice_date">{{ data.item.invoice_date | viewDate }}</span>
							</template>
							<template v-slot:cell(material_cost)="data">
								{{ data.item.material_cost | hr_money }}
							</template>
							<template v-slot:cell(work_net_amount)="data">
								{{ data.item.work_net_amount | hr_money }}
								<b-badge :variant="get_paymentBadge(data.item.work_net_amount, data.item.payments_labour)">{{ data.item.payments_labour | hr_money }}</b-badge>
							</template>
							<template v-slot:cell(spare_parts_net_amount)="data">
								{{ data.item.spare_parts_net_amount | hr_money }}
								<b-badge :variant="get_paymentBadge(data.item.spare_parts_net_amount, data.item.payments_part)">{{ data.item.payments_part | hr_money }}</b-badge>
							</template>
							<template v-slot:cell(invoice_net_amount)="data">
								{{ data.item.invoice_net_amount | hr_money }}
							</template>
							<template v-slot:cell(vat_amount)="data">
								{{ data.item.vat_amount | hr_money }}
							</template>
							<template v-slot:cell(total)="data">
								{{ (parseFloat(data.item.invoice_net_amount) + parseFloat(data.item.vat_amount)) | hr_money }}
								<b-badge :variant="get_paymentBadge(parseFloat(data.item.invoice_net_amount) + parseFloat(data.item.vat_amount), data.item.payments_total)">{{ data.item.payments_total | hr_money }}</b-badge>
							</template>
							<template v-slot:cell(status)="data">
								<b-badge v-if="data.item.confirmed != 0" variant="success">potrjeno</b-badge>
								<template v-else>
									<b-badge v-if="data.item.payments_total && parseFloat(data.item.payments_total) >= (parseFloat(data.item.invoice_net_amount) + parseFloat(data.item.vat_amount))" variant="success">v pripravi</b-badge>
									<b-badge v-else variant="danger">v pripravi</b-badge>
								</template>
							</template>
							<template v-slot:cell(actions)="data">
								<div>
									<b-button v-if="data.item.confirmed == 0" title="Potrdi plačilo" variant="primary" @click.stop="click_warrantyClaimsConfirmPayment(data.item)" size="sm" class="mr-2">
										<CIcon name="cil-cash"/>
									</b-button>
									<b-button v-if="data.item.confirmed != 0" title="Razveljavi plačilo" variant="warning" @click.stop="click_warrantyClaimsUnconfirmPayment(data.item)" size="sm" class="mr-2">
										<CIcon name="cil-cash"/>
									</b-button>
								</div>
							</template>
							<template slot="bottom-row">
								<td>Skupaj</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td>{{ warrantyClaimsTableProps.sum.material_cost | hr_money }}</td>
								<td>{{ warrantyClaimsTableProps.sum.work_net_amount | hr_money }}</td>
								<td>{{ warrantyClaimsTableProps.sum.spare_parts_net_amount | hr_money }}</td>
								<td>{{ warrantyClaimsTableProps.sum.invoice_net_amount | hr_money }}</td>
								<td>{{ warrantyClaimsTableProps.sum.vat_amount | hr_money }}</td>
								<td>{{ warrantyClaimsTableProps.sum.total | hr_money }}</td>
								<td></td>
								<td></td>
							</template>
							<template slot="row-details" slot-scope="data">
								Details
							</template>
						</b-table>
						<nav>
							<b-row>
								<b-col>
									<b-pagination :total-rows="warrantyClaimsTableProps.totalItems" :per-page="warrantyClaimsTableProps.itemsPerPage" v-model="warrantyClaimsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
								</b-col>
								<b-col cols=2>
									<a class="page-link rows_total float-right">Št. vrstic: {{ warrantyClaimsTableProps.totalItems }}</a>
								</b-col>
								<b-col cols=1>
									<b-form-select v-model="warrantyClaimsTableProps.itemsPerPage" :options="warrantyClaimsTableProps.options_numRowsOnPage"></b-form-select>
								</b-col>
							</b-row>
						</nav>
					</b-card>
				</b-tab>
				<b-tab title="Vplačila">
					<b-card>
						<vue-loading :active.sync="warrantyClaimPaymentsTableProps.isLoading" :is-full-page="false"/>
						<div slot="header">
							<div class="card-header-actions">
								<CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimPaymentsTableRefresh">
									<CIcon name="cil-loop-circular" class="mb-1"/>
								</CLink>
								<CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimPaymentsTableResetFilters">
									<CIcon name="cil-x" class="mb-1"/>
								</CLink>
								<CLink title="Uvozi plačila" href="#" class="card-header-action btn-setting" @click.stop="click_warrantyClaimPaymentsImport">
									<CIcon name="cil-cloud-upload" class="mb-1"/>
								</CLink>
							</div>
						</div>
						<b-table
							class="warrantyClaimPaymentsTable"
							ref="warrantyClaimPaymentsTable"
							responsive
							show-empty
							hover
							:empty-text="warrantyClaimPaymentsTableProps.empty_text"
							:empty-filtered-text="warrantyClaimPaymentsTableProps.empty_filtered_text"
							:fields="warrantyClaimPaymentsTableFields"
							:current-page="warrantyClaimPaymentsTableProps.currentPage"
							:per-page="warrantyClaimPaymentsTableProps.itemsPerPage"
							:items="warrantyClaimPaymentsTable_items"
							:sort-by.sync="warrantyClaimPaymentsTableProps.sortBy"
							:sort-desc.sync="warrantyClaimPaymentsTableProps.sortDesc"
							@row-clicked="rowClickedPayments">
							<template slot="top-row">
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
							</template>
						</b-table>
						<nav>
							<b-row>
								<b-col></b-col>
								<b-col cols=2>
									<a class="page-link rows_total float-right">Št. vrstic: {{ warrantyClaimPaymentsTableProps.totalItems }}</a>
								</b-col>
							</b-row>
						</nav>
					</b-card>
				</b-tab>
			</b-tabs>
		</b-card>
		<vue-toastr ref="toastr"></vue-toastr>
		<warranty-claims-upload-modal ref="warrantyClaimsImportModal" @emit_warrantyClaimsImportSuccess="emit_warrantyClaimsImportSuccess" />
		<warranty-claim-payments-upload-modal ref="warrantyClaimPaymentsImportModal" @emit_warrantyClaimPaymentsImportSuccess="emit_warrantyClaimPaymentsImportSuccess" />
		<warranty-claim-modal ref="warrantyClaimModal" />
	</div>
</template>

<script>
import settings from '@/settings.js';
import imagesTool from '@/tools/images';
import { WARRANTY_CLAIMS_LIST_FILTERED, WARRANTY_CLAIMS_ARCHIVE, WARRANTY_CLAIMS_UNARCHIVE } from "@/store/actions/warrantyClaims";
import { WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED } from "@/store/actions/warrantyClaimPayments";
import WarrantyClaimsImportModal from '@/views/modals/WarrantyClaimsImport';
import WarrantyClaimPaymentsImportModal from '@/views/modals/WarrantyClaimPaymentsImport';
import DateFilterDropdown from '@/views/components/DropdownFilters/DatumFilterDropdown';
import WarrantyClaimModal from '@/views/modals/WarrantyClaimModal';
import * as icons from '@coreui/icons';		

export default {
	name: 'Warranty-claims',
	components: {
		'date-filter-dropdown': DateFilterDropdown,
		'warranty-claims-upload-modal': WarrantyClaimsImportModal,
		'warranty-claim-payments-upload-modal': WarrantyClaimPaymentsImportModal,
		'warranty-claim-modal': WarrantyClaimModal,
	},
	data () {
		return {
			icons,
			settings,
			imagesTool,
			activeTab: 0,
			warrantyClaimsTableProps: {
				sortDesc: true,
				sortBy: '',
				currentPage: 1,
				itemsPerPage: 1000,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 50, text: '50' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' },
					{ value: 1000, text: '1000' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					invoiceNumber: null,
					invoiceDate: null,
					orderNumber: null,
					customerNumber: null,
					ordererTitle: null,
					showArchived: false
				},
				sum: {
					material_cost: 0,
					work_net_amount: 0,
					spare_parts_net_amount: 0,
					invoice_net_amount: 0,
					vat_amount: 0,
					total: 0,
					payments_total: 0
				},
				textFilterTimeout: null,
				errorText: ''
			},
			isLoadingConfirmingPayment: false,
			isLoadingUnconfirmingPayment: false,
			warrantyClaimPaymentsTableProps: {
				sortDesc: true,
				sortBy: '',
				currentPage: 1,
				itemsPerPage: 100,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 50, text: '50' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' },
					{ value: 1000, text: '1000' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					/*invoiceNumber: null,
					invoiceDate: null,
					orderNumber: null,
					customerNumber: null,
					ordererTitle: null,*/
				},
				textFilterTimeout: null,
				errorText: ''
			}
		}
	},
	computed: {
		profile() {
			return this.$store.getters.getProfile
		},
		warrantyClaimsTableFields: function () {
			let fields = [];
			fields.push({ key: 'invoice_type', label: 'Vr.', sortable: true, class: 'tdWarrantyClaimsXS'});
			fields.push({ key: 'invoice_number', label: 'Račun', sortable: true, class: 'tdWarrantyClaimsM'});
			fields.push({ key: 'invoice_date', label: 'Datum računa', sortable: true, class: 'tdWarrantyClaimsM'});
			fields.push({ key: 'order_number', label: 'Nalog', sortable: true, class: 'tdWarrantyClaimsM'});
			fields.push({ key: 'customer_number', label: 'Kupec', sortable: true, class: 'tdWarrantyClaimsM'});
			fields.push({ key: 'orderer_title', label: 'Naročnik', sortable: true });
			fields.push({ key: 'koda_str', label: 'Koda str.', sortable: true, class: 'tdWarrantyClaimsM' });
			fields.push({ key: 'material_cost', label: 'Material', sortable: true });
			fields.push({ key: 'work_net_amount', label: 'Delo', sortable: true });
			fields.push({ key: 'spare_parts_net_amount', label: 'Deli', sortable: true });
			fields.push({ key: 'invoice_net_amount', label: 'Skupaj', sortable: true });
			fields.push({ key: 'vat_amount', label: 'DDV', sortable: true });
			fields.push({ key: 'total', label: 'Skupaj z DDV', sortable: false });
			fields.push({ key: 'status', label: 'Status', sortable: false, class: 'tdWarrantyClaimsM'});
			fields.push({ key: 'actions', label: '#', sortable: false, class: 'tdEbillsActions text-right' });
			return fields;
		},
		warrantyClaimPaymentsTableFields: function () {
			let fields = [];
			fields.push({ key: 'cdp_invoice_number', label: 'Račun', sortable: true, class: 'tdWarrantyClaimsXS' });
			fields.push({ key: 'invoice_number', label: 'Račun', sortable: true, class: 'tdWarrantyClaims6' });
			fields.push({ key: 'order_number', label: 'DN', sortable: true, class: 'tdWarrantyClaimsM' });
			fields.push({ key: 'vin', label: 'VIN', sortable: true });
			fields.push({ key: 'expense_code', label: 'Koda', sortable: true });
			fields.push({ key: 'labour', label: 'Delo', sortable: true });
			fields.push({ key: 'part', label: 'Deli', sortable: true });
			fields.push({ key: 'grand_total', label: 'Skupaj', sortable: true });
			fields.push({ key: 'warranty_claim_id', label: 'GZ', sortable: true });
			fields.push({ key: 'claim_date', label: 'Datum plačila', sortable: true });
			fields.push({ key: 'created_at', label: 'Datum vnosa', sortable: true });
			return fields;
		}
	},
	methods: {
		click_warrantyClaimsTableRefresh: function () {
			this.warrantyClaimsTableProps.itemsPerPage = this.warrantyClaimsTableProps.options_numRowsOnPage[1].value;
			this.$refs.warrantyClaimsTable.refresh();
		},
		click_warrantyClaimsTableResetFilters: function () {
			this.warrantyClaimsTableProps.inputFilter.invoiceNumber = null;
			this.warrantyClaimsTableProps.inputFilter.invoiceDate = null;
			this.warrantyClaimsTableProps.inputFilter.orderNumber = null;
			this.warrantyClaimsTableProps.inputFilter.customerNumber = null;
			this.warrantyClaimsTableProps.inputFilter.ordererTitle = null;
			this.$refs.warrantyClaimsInvoiceDateFilter.click_clear();
			this.click_warrantyClaimsTableRefresh();
		},
		warrantyClaimsTable_items: function (ctx) {
			this.warrantyClaimsTableProps.isLoading = true;
			return this.$store.dispatch(WARRANTY_CLAIMS_LIST_FILTERED, { ctx: ctx, tableProps: this.warrantyClaimsTableProps })
				.then((responseData) => {
					this.warrantyClaimsTableProps.items = responseData.warrantyClaimsPagination.data;
					// calculate sums
					this.warrantyClaimsTableProps.sum.material_cost = 0;
					this.warrantyClaimsTableProps.sum.work_net_amount = 0;
					this.warrantyClaimsTableProps.sum.spare_parts_net_amount = 0;
					this.warrantyClaimsTableProps.sum.invoice_net_amount = 0;
					this.warrantyClaimsTableProps.sum.vat_amount = 0;
					this.warrantyClaimsTableProps.sum.total = 0;
					this.warrantyClaimsTableProps.sum = this.warrantyClaimsTableProps.items.reduce((sum, item) => {
						sum.material_cost = sum.material_cost + parseFloat(item.material_cost ?? 0);
						sum.work_net_amount = sum.work_net_amount + parseFloat(item.work_net_amount ?? 0);
						sum.spare_parts_net_amount = sum.spare_parts_net_amount + parseFloat(item.spare_parts_net_amount ?? 0);
						sum.invoice_net_amount = sum.invoice_net_amount + parseFloat(item.invoice_net_amount ?? 0);
						sum.vat_amount = sum.vat_amount + parseFloat(item.vat_amount ?? 0);
						sum.total = sum.total + (parseFloat(item.invoice_net_amount ?? 0) + parseFloat(item.vat_amount ?? 0));
						return sum;
					}, this.warrantyClaimsTableProps.sum);
					this.warrantyClaimsTableProps.totalItems = responseData.warrantyClaimsPagination.total;
					this.warrantyClaimsTableProps.empty_text = 'Ni vnosov';
					this.warrantyClaimsTableProps.isLoading = false;
					return responseData.warrantyClaimsPagination.data;
				})
				.catch(error => {
					this.warrantyClaimsTableProps.isLoading = false;
					this.warrantyClaimsTableProps.items = [];
					this.warrantyClaimsTableProps.totalItems = 0;
					this.warrantyClaimsTableProps.empty_text = 'Napaka pri pridobivanju garancijskih zahtevkov';
					console.log(error);
					return [];
				});
		},
		warrantyClaimsTableTextFilter_change: function (value) {
			if (this.warrantyClaimsTableProps.textFilterTimeout !== null) {
				clearTimeout(this.warrantyClaimsTableProps.textFilterTimeout);
			}
			this.warrantyClaimsTableProps.textFilterTimeout = setTimeout(() => {
				this.click_warrantyClaimsTableRefresh();
			}, settings.filterTimeoutLength);
		},
		warrantyClaimsTableFilter_change: function (value) {
			this.click_warrantyClaimsTableRefresh();
		},
		change_showArchived: function () {
			this.$refs.warrantyClaimsTable.refresh();
		},
		rowClicked (row) {
			//row._showDetails = !row._showDetails;
			const modalInput = {
				mode: 1,
				warrantyClaim: row
			};
			this.$refs.warrantyClaimModal.showModal(modalInput);
		},
		click_warrantyClaimsConfirmPayment: function (data) {
			this.$bvModal.msgBoxConfirm('Želite potrditi garancijski zahtevek #' + data.invoice_number + '?', {
				title: 'Potrdite garancijski zahtevek',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.isLoadingConfirmingPayment = true;
					this.$store.dispatch(WARRANTY_CLAIMS_ARCHIVE, { id: data.id })
						.then((responseData) => {
							this.isLoadingConfirmingPayment = false;
							this.$refs.toastr.s('Zahtevek #' + data.invoice_number + ' uspešno potrjen.');
							this.$refs.warrantyClaimsTable.refresh();
						})
						.catch(error => {
							this.isLoadingConfirmingPayment = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri potrjevanju zahtevka! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri potrjevanju zahtevka! Prosimo poizkusite kasneje.');
							}
						});
				}
			}).catch(err => {
				console.error(err);
			})
		},
		click_warrantyClaimsUnconfirmPayment: function (data) {
			this.$bvModal.msgBoxConfirm('Želite zavrniti garancijski zahtevek #' + data.invoice_number + '?', {
				title: 'Zavrnite garancijski zahtevek',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.isLoadingUnconfirmingPayment = true;
					this.$store.dispatch(WARRANTY_CLAIMS_UNARCHIVE, { id: data.id })
						.then((responseData) => {
							this.isLoadingUnconfirmingPayment = false;
							this.$refs.toastr.s('Zahtevek #' + data.invoice_number + ' uspešno zavrnjen.');
							this.$refs.warrantyClaimsTable.refresh();
						})
						.catch(error => {
							this.isLoadingUnconfirmingPayment = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri zavrnitvi zahtevka! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri zavrnitvi zahtevka! Prosimo poizkusite kasneje.');
							}
						}); 
				}
			}).catch(err => {
				console.error(err);
			})
		},
		click_warrantyClaimsImport: function () {
			this.$refs.warrantyClaimsImportModal.showModal();
		},
		emit_warrantyClaimsImportSuccess: function () {
			this.$refs.warrantyClaimsTable.refresh();
		},
		click_warrantyClaimPaymentsTableRefresh: function () {
			this.warrantyClaimPaymentsTableProps.itemsPerPage = this.warrantyClaimPaymentsTableProps.options_numRowsOnPage[1].value;
			this.$refs.warrantyClaimPaymentsTable.refresh();
		},
		click_warrantyClaimPaymentsTableResetFilters: function () {
			/*this.warrantyClaimsTableProps.inputFilter.invoiceNumber = null;
			this.warrantyClaimsTableProps.inputFilter.invoiceDate = null;
			this.warrantyClaimsTableProps.inputFilter.orderNumber = null;
			this.warrantyClaimsTableProps.inputFilter.customerNumber = null;
			this.warrantyClaimsTableProps.inputFilter.ordererTitle = null;*/
			//this.$refs.warrantyClaimsInvoiceDateFilter.click_clear();
			this.click_warrantyClaimPaymentsTableRefresh();
		},
		warrantyClaimPaymentsTable_items: function (ctx) {
			this.warrantyClaimPaymentsTableProps.isLoading = true;
			return this.$store.dispatch(WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED, { ctx: ctx, tableProps: this.warrantyClaimPaymentsTableProps })
				.then((responseData) => {
					this.warrantyClaimPaymentsTableProps.isLoading = false;
					this.warrantyClaimPaymentsTableProps.items = responseData.warrantyClaimPaymentsPagination.data;
					this.warrantyClaimPaymentsTableProps.totalItems = responseData.warrantyClaimPaymentsPagination.total;
					this.warrantyClaimPaymentsTableProps.empty_text = 'Ni vnosov';
					return responseData.warrantyClaimPaymentsPagination.data;
				})
				.catch(error => {
					this.warrantyClaimPaymentsTableProps.isLoading = false;
					this.warrantyClaimPaymentsTableProps.items = [];
					this.warrantyClaimPaymentsTableProps.totalItems = 0;
					this.warrantyClaimPaymentsTableProps.empty_text = 'Napaka pri pridobivanju plačil zahtevkov';
					console.log(error);
					return [];
				});
		},
		rowClickedPayments (row) {
			/*const modalInput = {
				mode: 1,
				warrantyClaim: row
			};
			this.$refs.warrantyClaimModal.showModal(modalInput);*/
		},
		click_warrantyClaimPaymentsImport: function () {
			this.$refs.warrantyClaimPaymentsImportModal.showModal();
		},
		emit_warrantyClaimPaymentsImportSuccess: function () {
			this.$refs.warrantyClaimPaymentsTable.refresh();
		},
		get_paymentBadge: function (requested, received) {
			let tolerance_min = requested * 0.1; // 10 %
			if(received > (requested - tolerance_min)) {
				let tolerance_max = requested * 0.2; // 20 %
				if(received > (requested + tolerance_max)) {
					return 'warning';
				} else {
					return 'success';
				}
			} else {
				return 'danger';
			}
		},
	},
	created: function () {
	},
	mounted() {
	}
}
</script>
<style scoped>
.table-responsive-sm {
	margin-bottom: 0;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
</style>
<style>
.tdWarrantyClaimsXS {
	width: 2rem;
	min-width: 2rem;
}
.tdWarrantyClaimsS {
	width: 5rem;
	min-width: 5rem;
}
.tdWarrantyClaims6 {
	width: 6rem;
	min-width: 6rem;
}
.tdWarrantyClaimsM {
	width: 8rem;
	min-width: 8rem;
}
.tdWarrantyClaims10 {
	width: 10rem;
	min-width: 10rem;
}
.warrantyClaimsTable {
	min-height: 500px;
}
.table thead th[aria-sort="descending"] {
	cursor: pointer;
}
.table thead th[aria-sort="descending"] div:after {
	content:'↓';
	margin-left: 0.5em;
}
.table thead th[aria-sort="ascending"] {
	cursor: pointer;
}
.table thead th[aria-sort="ascending"] div:after {
	content:'↑';
	margin-left: 0.5em;
}
.table thead th[aria-sort="none"] {
	cursor: pointer;
}
</style>